import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.swiper-logos', {
        modules: [Pagination, Autoplay],
        autoplay: {
            delay: 2500,
        },
        loop: true,
        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 8,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
        },
        breakpoints: {
            640: {
                spaceBetween: 12,
                slidesPerView: 4,
            },
            768: {
                spaceBetween: 16,
                slidesPerView: 5,
            },
            992: {
                spaceBetween: 20,
                slidesPerView: 6,
            },
        },
    });


    new Swiper('.swiper-cards', {
        modules: [Navigation],
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 800,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                spaceBetween: 16,
                slidesPerView: 2,
            },
        },
    });
});
